import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Tarea } from 'app/models/tareas.model';
import { FormTypeWidgetComponent } from 'app/modules/GlobalComponents/id-formulario-widget.component';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { UserAvatarWidgetComponent } from 'app/modules/GlobalComponents/user-avatar-component';

@Component({
    selector: 'tabla-gestiones',
    templateUrl: 'tabla-gestiones.component.html',
    imports:[
        MatTableModule,
        CommonModule,

        //component

        StatusStickerComponent,
        FormTypeWidgetComponent,
        UserAvatarWidgetComponent
    ]
})

export class TablaGestionesComponent implements OnInit {
    @Input() dataSourseGestiones= new MatTableDataSource<Tarea>
        gestionesTableColumns: string[] = [
            'form-id',
            'gestion',
            'estado',
            'solicitante',
            'origen',
            'usuariosAsignados',
            'fecha-ingreso',
        ];
    
    constructor(private router: Router) { }

    ngOnInit() { }

    openTaskDetails(task_uuid: string) {
        this.router.navigate(['/task-details/task/', task_uuid]);
    }
}